import { businessDayOf } from "./businessDay";

export type BouquetAgeTone = "fresh" | "ageing" | "old";

export interface BouquetAge {
  label: string;
  tone: BouquetAgeTone;
}

const MS_PER_DAY = 86_400_000;

function dayNumber(instant: Date): number {
  const { year, month, day } = businessDayOf(instant);
  return Math.floor(Date.UTC(year, month - 1, day) / MS_PER_DAY);
}

/**
 * G-132 — how long a ready bouquet has sat on the shelf, in Barcelona calendar
 * days (the day the shop counts in, `businessDay.ts`), not 24-hour blocks: a
 * bouquet made at 22:00 is "Made yesterday" at 09:00 the next morning.
 * 0–1 days fresh, 2–3 ageing, 4 or more old.
 */
export function bouquetAge(createdAt: string, now: Date = new Date()): BouquetAge {
  const made = new Date(createdAt);
  if (Number.isNaN(made.getTime())) return { label: "Made earlier", tone: "old" };
  const days = Math.max(0, dayNumber(now) - dayNumber(made));
  const label =
    days === 0 ? "Made today" : days === 1 ? "Made yesterday" : `Made ${days} days ago`;
  const tone: BouquetAgeTone = days <= 1 ? "fresh" : days <= 3 ? "ageing" : "old";
  return { label, tone };
}
